import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { usePlatformAuth } from "./context/PlatformAuthContext";
import { PlatformLayout } from "./components/layout/PlatformLayout";
import { OverviewPage } from "./pages/OverviewPage";
import { OrganizationsPage } from "./pages/OrganizationsPage";
import { PublicationsPage } from "./pages/PublicationsPage";
import { AuditLogsPage } from "./pages/AuditLogsPage";
import { LoginPage } from "./pages/LoginPage";
import { SecuritySettingsPage } from "./features/settings/pages/SecuritySettingsPage";
import { PlatformSupportPage } from "./pages/PlatformSupportPage";
import { PlatformSupportDetailPage } from "./pages/PlatformSupportDetailPage";
import { TemporalJobsPage } from "./pages/TemporalJobsPage";
import { VendorsMarketplacePage } from "./pages/VendorsMarketplacePage";
import { PropertiesMarketplacePage } from "./pages/PropertiesMarketplacePage";
import { Spinner } from "@homy/ui";

function ProtectedRoute() {
  const { isAuthenticated, isLoading } = usePlatformAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-background text-foreground space-y-3">
        <Spinner className="h-8 w-8 text-primary" />
        <p className="text-xs text-muted-foreground font-mono">
          Verifying platform operator session...
        </p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <PlatformLayout />;
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Platform Console Routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<Navigate to="/overview" replace />} />
        <Route path="/overview" element={<OverviewPage />} />
        <Route path="/organizations" element={<OrganizationsPage />} />
        <Route path="/publications" element={<PublicationsPage />} />
        <Route path="/marketplaces/vendors" element={<VendorsMarketplacePage />} />
        <Route path="/marketplaces/properties" element={<PropertiesMarketplacePage />} />
        <Route path="/temporal" element={<TemporalJobsPage />} />
        <Route path="/jobs" element={<Navigate to="/temporal" replace />} />
        <Route path="/support" element={<PlatformSupportPage />} />
        <Route path="/support/:id" element={<PlatformSupportDetailPage />} />
        <Route path="/audit-logs" element={<AuditLogsPage />} />
        <Route path="/settings" element={<SecuritySettingsPage />} />
        <Route path="/security" element={<Navigate to="/settings" replace />} />
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
